import { convertToURLSearchParams, ServiceClient } from "@/util";
import { ScopeOfWork } from "./scopesOfWork";
import { TestEvent } from "./testEvents";

export type ScopeOfWorkPrintOptions = {
  summary?: boolean;
  advisories?: boolean;
  rangeQualifiedSummary?: boolean;
  welderCertifications?: boolean;
  continuityReport?: boolean;
};

export type TestEventPrintOptions = {
  summary?: boolean;
  results?: boolean;
};

export type WelderPrintOptions = {
  summary?: boolean;
  certifications?: boolean;
  welderRenewalLog?: boolean;
  expirations?: boolean;
};

export function printScopeOfWork(scope: ScopeOfWork, options: ScopeOfWorkPrintOptions) {
  const params = convertToURLSearchParams(options);
  ServiceClient.redirect(`williams/report/sow/${scope.id}`, params.toString());
}

export function printTestEvent(event: TestEvent, options: TestEventPrintOptions) {
  const params = convertToURLSearchParams(options);
  ServiceClient.redirect(`williams/report/event/${event.id}`, params.toString());
}

export function printWelder(id: string | string[], options: WelderPrintOptions) {
  const params = convertToURLSearchParams(options);
  ServiceClient.redirect(`williams/report/welder/${id}`, params.toString());
}

export function printCertificate(id: string | string[]) {
  ServiceClient.redirect(`williams/report/certificate/${id}`);
}

export function downloadDataPack(id: string) {
  ServiceClient.redirect(`williams/report/datapack/${id}`);
}
